// Formats a purchase's per-business transaction_number (see schema.prisma /
// customerpackage.ts buyPackageByCustomerId) for display. Same underlying
// number, different prefix per document kind — e.g. TRX-000042 in the app,
// INV-000042 on the Invoice PDF, RCP-000042 on the Receipt PDF — so the two
// documents for one sale read as a matched pair while still visibly saying
// which one they are.
export const formatTransactionNumber = (
  prefix: string,
  transactionNumber: number | null
): string =>
  transactionNumber == null
    ? "-"
    : `${prefix}-${String(transactionNumber).padStart(6, "0")}`;
